// src/hooks/useLoginForm.js
import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

export default function useLoginForm() {
  const { login } = useAuth();
  
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e, onSuccess) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await login(email, password);

      if (typeof onSuccess === 'function') {
        onSuccess(); // 🧠 let the component handle navigation
      }
    } catch (err) {
      setError('Login failed: ' + (err.response?.data?.message || 'Try again'));
    } finally {
      setLoading(false);
    }
  };

  return {
    email,
    setEmail,
    password,
    setPassword,
    error,
    loading,
    handleSubmit,
  };
}